import Router from 'next/router';
import customerDetails from '../customerDetails';
import { getSspLoginPath } from './routesUtil';

export const handleLogout = () => {
  customerDetails.clearCustomerDetails();
  window.GorgiasChat !== undefined && window.GorgiasChat.logoutSSP();
  Router.push(getSspLoginPath());
};
